module.exports = __webpack_public_path__ + "eizo_EV2316W_icon.svg?04f82e09ede75d50a3151afe34f99ad2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/eizo_EV2316W_icon.svg
// module id = 219
// module chunks = 0